import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import SvgIcon from '../../ui/theme/common/svgicon/svgicon.jsx'
import CircleButton from '../CircleButton/CircleButton.jsx'
import Dots from '../Dots/Dots.jsx'

const StyledPagination = styled.div`
  margin: 0.9rem 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const PrevButton = styled(CircleButton)`
  margin-right: 12px;
  width: 32px;
`

const NextButton = styled(CircleButton)`
  margin-left: 12px;
  width: 32px;
`

const PaginationItem = styled(CircleButton)`
  margin: 0 4px;
`

class Pagination extends Component {
  static currentPageIsValid = (pages, currentPage) =>
    pages >= 2 && (currentPage < 1 || currentPage > pages)

  static propTypes = {
    pages: PropTypes.number.isRequired,
    currentPage: function (props, propName, componentName) {
      if (Pagination.currentPageIsValid(props.pages, props[propName])) {
        return new Error(
          `Invalid initial ${propName} supplied to ${componentName}`
        )
      }
    },
    onPaginate: PropTypes.func.isRequired
  }

  static defaultProps = {
    pages: 0,
    currentPage: 1,
    onPaginate: null
  }

  componentDidMount = () =>
    window.addEventListener('keydown', this.keyboardControls)

  componentWillUnmount = () =>
    window.removeEventListener('keydown', this.keyboardControls)

  keyboardControls = e => {
    const { currentPage, pages } = this.props

    if (e.key === 'ArrowLeft' && currentPage - 1 > 0) this.handlePrevClick()
    if (e.key === 'ArrowRight' && currentPage + 1 <= pages) { this.handleNextClick() }
  }

  handlePrevClick = () => this.paginateTo(this.props.currentPage - 1)
  handleNextClick = () => this.paginateTo(this.props.currentPage + 1)

  paginateTo = pageNr => {
    if (pageNr < 1 || pageNr > this.props.pages) {
      throw new Error('invalid page number')
    }

    this.props.onPaginate(pageNr)
  }

  getCenter = () => {
    const { currentPage, pages } = this.props

    const lengthLeft = currentPage - 1
    const lengthRight = pages - currentPage

    const dotsLeft = lengthLeft > 3
    const dotsRight = lengthRight > 3

    const ignoreDots = pages <= 7

    let items = []

    if (ignoreDots || (!dotsLeft && !dotsRight)) { items = [...Array(pages - 2).keys()].map(x => x + 2) } else if (dotsLeft && !dotsRight) { items = ['dots', ...[...Array(4).keys()].map(x => x + (pages - 4))] } else if (!dotsLeft && dotsRight) items = [2, 3, 4, 5, 'dots']
    else if (dotsLeft && dotsRight) { items = ['dots', currentPage - 1, currentPage, currentPage + 1, 'dots'] }

    return items.map((item, index) =>
      item !== 'dots' ? (
        <PaginationItem
          onClick={e => this.paginateTo(item, e)}
          key={`${item}-${index}`}
          active={currentPage === item}
        >
          {item}
        </PaginationItem>
      ) : (
        <Dots key={`${item}-${index}`} />
      )
    )
  }

  render () {
    const { currentPage, pages } = this.props

    return (
      <>
        {pages >= 2 && (
          <StyledPagination>
            <PrevButton
              onClick={this.handlePrevClick}
              hidden={currentPage === 1}
            >
              <SvgIcon name='arrow-left' size='16' className='icon' />
            </PrevButton>
            <PaginationItem
              onClick={this.paginateTo.bind(this, 1)}
              active={currentPage === 1}
            >
              1
            </PaginationItem>

            {this.getCenter()}

            <PaginationItem
              onClick={this.paginateTo.bind(this, pages)}
              active={currentPage === pages}
            >
              {pages}
            </PaginationItem>
            <NextButton
              onClick={this.handleNextClick}
              hidden={currentPage === pages}
            >
              <SvgIcon name='arrow-right' size='16' className='icon' />
            </NextButton>
          </StyledPagination>
        )}
      </>
    )
  }
}

export default Pagination
